import { styled, AccordionDetails } from '@mui/material';

export const CustomAccordionDetails = styled(AccordionDetails)(() => ({
	'&&': {
		padding: 0,
	},
}));
